window.axios = require("axios");
// window.axios.defaults.headers.common["X-WP-Nonce"] = settings.nonce;
import {
    createApp
} from "vue";
import mixins from "./mixins";
import api from "./api";
import SvgVue from "svg-vue3";
import {
    UtilitiesHelpers
} from "./utils/Utilities";
import {
    gsap
} from "gsap/dist/gsap";
import {
    ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
    ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";            
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const mainContent = document.getElementById('site');
const preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
    paused: false, // default is false
    smoothChildTiming: true,
});
headerBarAnimate
    .fromTo(
        headerBar, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.5,
        },
        "<.2")
    .fromTo(headerBar, {
        scale: 0.95
    }, {
        scale: 1,
        duration: 1
    }, "<.1");
import LazyLoadDirective from "./directives/LazyLoadDirective";
import ClickOutside from "./directives/ClickOutside";
import PricingPage from "./vueresources/pricing.vue";
import 'vue-universal-modal/dist/index.css';
import VueUniversalModal from 'vue-universal-modal';
let pricingApp = document.getElementById('pricing-app');
pricingApp = createApp({
        beforeCreate() {
            UtilitiesHelpers.vueFixWpPlugins(document.querySelector('#pricing-app'));
            UtilitiesHelpers.forceExternalLinks();
        },
    })
    .use(SvgVue)
    .use(VueUniversalModal, {
        teleportTarget: '#vue-modals',
    })
    .directive("lazyload", LazyLoadDirective)
    .directive("click-outside", ClickOutside);
pricingApp.config.globalProperties.$images = settings.images;
pricingApp.config.globalProperties.$settings = settings;
pricingApp.config.globalProperties.$api = api;
pricingApp.config.globalProperties.$nonce = settings.nonce;
pricingApp.mixin(mixins);
pricingApp.component("orely-pricing", PricingPage);
pricingApp.mount('#pricing-app');
const dropdownSelectDifference = document.getElementById('dropdownSelectDifference');
const menuItems = document.querySelectorAll('.menuSelect');
const contentDropdownSelect = document.querySelector('.contentDropdownSelect');
const dropdownDifference = document.querySelector('.dropdown-difference')
menuItems.forEach(menuItem => {
    menuItem.addEventListener('click', function () {
        const selectedText = menuItem.textContent;
        const titleDifference = document.querySelector('.TitleDifference');
        titleDifference.textContent = selectedText;
        dropdownDifference.classList.remove('active')
    });
});
dropdownSelectDifference.addEventListener('click', function () {
    dropdownDifference.classList.toggle('active');
});
function showFeature(feature) {
    // Hide all feature sections first
    const featureSections = document.querySelectorAll('[id^="feature"]');
    featureSections.forEach(section => section.classList.add('hidden'));
    // Show the selected feature section
    const selectedFeatureSection = document.getElementById(`feature${feature.replace(/\s+/g, '')}`);
    if (selectedFeatureSection) {
        selectedFeatureSection.classList.remove('hidden');
    }
}
let elDropdownItem = document.querySelectorAll('.contentDropdownSelect button.menuSelect');
for (let index = 0; index < elDropdownItem.length; index++) {
    const element = elDropdownItem[index];
    element.addEventListener('click', function (events) {
        showFeature(events.target.attributes.id.value);
    })
}
let sectionPagesPricing = gsap.timeline({
    paused: true, // default is false
    defaults: { // children inherit these defaults

        ease: "power2.out"
    },
    smoothChildTiming: true,
});
sectionPagesPricing
    .fromTo('.page-titlePricing', {
        scale: 1.2,
        opacity: 0,
    }, {
        duration: 1,
        scale: 1,
        opacity: 1,
        stagger: .2,
    }, '<.1')
    .fromTo('.pricing-form .right', {
        y: '100px',
        opacity: 0,

    }, {
        duration: 1.5,
        y: '0px',
        opacity: 1,

    }, '<.9')
    .fromTo('.pricing-form .left .content', {
        y: '100px',
        opacity: 0,

    }, {
        duration: 1.5,
        y: '0px',
        opacity: 1,
        scale: 1
    }, '<.1')

let timelineDifference = gsap.timeline({
    scrollTrigger: '.sectionDiff',
    start: "top center",
})
timelineDifference
    .fromTo('.differenceContent table tbody tr td p', {
        y: '20px',
        opacity: 0,

    }, {
        duration: .5,
        y: '0px',
        opacity: 1,
        stagger: .05
    }, '>.1')
let timelineTry = gsap.timeline({
    scrollTrigger: {
        trigger: '.sectionTry',
        start: 'top 80%',
        end: 'top top ',
        // markers: true
    },
    defaults: {
        ease: "power2.out"
    },
})
timelineTry
    .fromTo('.contentTry .tryWrapper .itemTry', {
        y: '40px',
        opacity: 0
    }, {
        duration: 1.5,
        y: '0px',
        opacity: 1,
        stagger: .2
    }, '<.1')
    .fromTo('.contentTry img', {
        scale: 1.2,
    }, {
        duration: 1.5,
        scale: 1
    }, '<.1')
let timelineCheckout = gsap.timeline({
    scrollTrigger: '.sectionCheckout',
    start: "bottom bottom",
    paused: false, // default is false
    defaults: { // children inherit these defaults
        duration: 1,
        ease: "power2.out"
    },
})
timelineCheckout
    .fromTo(' .textCheck', {
        y: '100px',
        opacity: 0
    }, {
        y: '0px',
        opacity: 1,
        stagger: .4
    })
    .fromTo('.imgCheck', {
        scale: 1.2,
    }, {
        scale: 1,
    }, '<.1')
let timelineFAQ = gsap.timeline({
    scrollTrigger: '.FAQ-wrapper',
    start: "bottom bottom",
    paused: false, // default is false
    defaults: { // children inherit these defaults
        duration: 1,
        ease: "power2.out"
    },
})
timelineFAQ.fromTo('.faq', {
    y: '30px',
    opacity: 0,
    duration: 1,
}, {
    y: '0px',
    opacity: 1,
    stagger: 0.2
})
document.addEventListener("DOMContentLoaded", function () {
    if (preLoaderEl) {
        setTimeout(function () {
            preLoaderEl.classList.add('hide');
            mainContent.classList.remove('overflow-hidden');
            mainContent.classList.remove('opacity-0');
            mainContent.classList.add('opacity-100');
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });        
        headerBarAnimate.play();
        }, 1300)
    }  
    sectionPagesPricing.play();
})